import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "../../../contexts/ThemeContext";
import { openDrawer } from "../../../redux/slices/menu/menuSlice";
import useResponsive from "../../../hooks/useResponsive";
import HeaderContent from "./HeaderContent";

function Header() {
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const drawerOpen = useSelector((s) => s.menu.drawerOpen);
  const { isDesktop } = useResponsive();

  return (
    <header
      style={{
        ...styles.header,
        backgroundColor: theme.surface,
        borderColor: theme.border,
        marginLeft: isDesktop && drawerOpen ? 260 : 0,
        transition: "margin-left 0.3s ease",
      }}
    >
      <div style={styles.left}>
        <button
          onClick={() => dispatch(openDrawer({ drawerOpen: !drawerOpen }))}
          style={{ ...styles.toggle, color: theme.textSecondary }}
          title={drawerOpen ? "Close sidebar" : "Open sidebar"}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {drawerOpen ? (
              // <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></>
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>
      </div>
      <HeaderContent />
    </header>
  );
}

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 24px",
    height: 60,
    borderBottom: "1px solid",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 100,
  },
  left: {
    display: "flex",
    alignItems: "center",
  },
  toggle: {
    width: 32,
    height: 32,
    borderRadius: 8,
    border: "none",
    background: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default Header;
